import { useState, useEffect, useRef } from 'react';
import _ from 'lodash';

const MediaGalleryModal = ({ images, toggleModal }) => {

    const getScreenWidth = (referenceWidth) => {
        return window.innerWidth <= referenceWidth ? referenceWidth : 1920;
    };

    const containerRef = useRef(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [transformValue, setTransformValue] = useState(0);
    const [imageWidth, setImageWidth] = useState(getScreenWidth(1366));

    useEffect(() => {
        const handleResize = () => {
            setImageWidth(getScreenWidth(1366));
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {        
        if (!containerRef.current) return;

        const container = containerRef.current;
        const activeImage = container.querySelectorAll('.gallery-modal-image-wrapper')[currentImageIndex];
        if (!activeImage) return;

        const containerWidth = container.parentElement.offsetWidth;
        const imageRect = activeImage.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        
        
        const imageCenter = imageRect.left + imageRect.width / 2;
        const containerCenter = containerRect.left + containerWidth / 2;

        setTransformValue(containerCenter - imageCenter);       
       
    }, [currentImageIndex, imageWidth]);

    const handleImageClick = (event) => {
        event.stopPropagation();
    };

    const goToNextImage = () => {
        if (currentImageIndex < images.length - 1) {
            const newIndex = currentImageIndex + 1;
            setCurrentImageIndex(newIndex);            
        }
    };

    const goToPreviousImage = () => {
        if (currentImageIndex > 0) {
            const newIndex = currentImageIndex - 1;
            setCurrentImageIndex(newIndex);            
        }
    };

    const numberOfImages = images.length;
    const trackWidth = `${numberOfImages * 100}%`;
    const wrapperWidth = `${(100 / numberOfImages).toFixed(5)}%`;

    return (
        <>
            <div className="fullscreen">
                <div id="gallery-modal-blanket" style={{
                    transition: 'opacity 200ms',
                    opacity: 1,
                }}></div>
                <div id="gallery-modal-positioner"
                    style={{
                        transition: 'transform 300ms cubic-bezier(0.23, 1, 0.32, 1), opacity 300ms cubic-bezier(0.23, 1, 0.32, 1)',
                        transform: 'translate3d(0px, 0px, 0px)',
                        opacity: 1,
                    }}>
                    <div id="gallery-modal-dialog">
                        <div id="gallery-modal-container">
                            <div id="gallery-modal-header" style={{
                                background: 'linear-gradient(rgba(0, 0, 0, 0.33), rgba(0, 0, 0, 0))',
                            }}>
                                <span></span>
                                <span>
                                    <button type="button" title="Close (esc)"
                                        onClick={toggleModal}
                                        className="gallery-modal-button">
                                        <svg role="presentation" viewBox="0 0 24 24" className="gallery-modal-svg">
                                            <path d="M18.984 6.422l-5.578 5.578 5.578 5.578-1.406 1.406-5.578-5.578-5.578 5.578-1.406-1.406 5.578-5.578-5.578-5.578 1.406-1.406 5.578 5.578 5.578-5.578z">
                                            </path>
                                        </svg>
                                    </button>
                                </span>
                            </div>
                            <main id="gallery-modal-pager" style={{ flex: '1 1 auto', position: 'relative' }}>
                                <div tabIndex="0" id="gallery-modal-frame" style={{ position: 'relative', overflow: 'hidden', outline: '0px' }}>
                                    <div id="gallery-modal-track"
                                        ref={containerRef}
                                        style={{ display: 'flex', alignItems: 'center', transform: `translate3d(${transformValue}px, 0px, 0px)`, width: trackWidth }}>
                                        {images.map((image, index) => (
                                            <div
                                                className="gallery-modal-image-wrapper"
                                                key={index}
                                                onClick={handleImageClick}
                                                style={{ display: 'inline-block', verticalAlign: 'top', width: wrapperWidth }}>
                                                <div className="gallery-modal-image-view">
                                                    <img src={image.source} id={image.id} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <nav id="gallery-modal-nav">
                                    {currentImageIndex > 0 && (
                                        <button type="button" title="Previous (left arrow)" id="gallery-modal-previous"
                                            onClick={goToPreviousImage}>
                                            <svg role="presentation" viewBox="0 0 24 24" className="css-8wgz7g">
                                                <path d="M15.422 16.078l-1.406 1.406-6-6 6-6 1.406 1.406-4.594 4.594z"></path>
                                            </svg>
                                        </button>
                                    )}
                                    {currentImageIndex < images.length - 1 && (
                                        <button type="button" title="Next (right arrow)" id="gallery-modal-next"
                                            onClick={goToNextImage}>
                                            <svg role="presentation" viewBox="0 0 24 24" className="css-8wgz7g">
                                                <path d="M9.984 6l6 6-6 6-1.406-1.406 4.594-4.594-4.594-4.594z"></path>
                                            </svg>
                                        </button>
                                    )}
                                </nav>
                            </main>
                            <div id="gallery-modal-footer">
                                <span>
                                    {currentImageIndex + 1} / {images.length}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MediaGalleryModal;
